import { useState } from "react";
import IMG from "../../images/logo.png";
import { Link } from "react-scroll";

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="w-full relative">
      <div className="flex w-full justify-between items-center px-1 lg:px-16  -mt-4">
        
        <img src={IMG} className="w-40 lg:w-52" />

        {/* HAMBURGER (MOBILE ONLY) */}
        <div
          className="block lg:hidden text-4xl cursor-pointer mr-1"
          onClick={() => setOpen(!open)} >
          ☰
        </div>

        {/* NAV (DESKTOP ONLY) */}
        <nav className="hidden lg:flex gap-8 text-base font-poppins">
           <Link className="cursor-pointer hover:text-primary font-medium " to="about" smooth={true} duration={500}>About</Link>
           <Link className="cursor-pointer hover:text-primary font-medium  " to="objectives" smooth={true} duration={500}>Vision, Mission & Objectives</Link>
           <Link className="cursor-pointer hover:text-primary font-medium " to="workshops" smooth={true} duration={500}>Workshops</Link>
           <Link className="cursor-pointer hover:text-primary font-medium  " to="tay-talk" smooth={true} duration={500}>Tay Talk</Link>
           <Link className="cursor-pointer hover:text-primary font-medium  " to="founder" smooth={true} duration={500}>Founder</Link>
        </nav>
      </div>

    {/* MOBILE MENU */}
{open && (
  <div className="bg-white block lg:hidden absolute shadow-md right-3 p-6 z-50 top-17 rounded-md">
    <nav className="flex flex-col gap-4 bg-white text-sm font-poppins">
      <Link onClick={() => setOpen(false)} to="about" smooth={true} duration={500}>About</Link>
      <Link onClick={() => setOpen(false)} to="objectives" smooth={true} duration={500}>Vision, Mission & Objectives</Link>
      <Link onClick={() => setOpen(false)} to="workshops" smooth={true} duration={500}>Workshops</Link>
      <Link onClick={() => setOpen(false)} to="tay-talk" smooth={true} duration={500}>Tay Talk</Link>
      <Link onClick={() => setOpen(false)} to="founder" smooth={true} duration={500}>Founder</Link>
    </nav>
  </div>
)}
    </div>
  );
};

export default Header;
